<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12><Navbar :backButtonPath="backPath"/></v-flex>
      <responsive-flex>
        <v-flex xs12>
          <LoanInput
            v-bind="{
              showLoanError
            }"
            :title = "inputTitle"
            v-model.lazy="loanAmount"
            @blur="blurFunction"
            @focus="makeDisclaimerVisible"
          />
          <disclaimer-tooltip
            :text="disclaimerText"
            v-show="showDisclaimer"
            class="px-4"
            id="loan-disclaimer"
          />
        </v-flex>
        <AppNextButton
          :buttonFunction="calculateEstimates"
          btnId="gtm.estimator"
        >
          Estimate
        </AppNextButton>
        <LenderCard :lender="lender"/>
        <v-radio-group
          v-model="currentPlan"
          v-if="showEstimates"
        >
          <v-flex xs12
            v-for="plan in allPlans"
            :key="plan.id"
          >
            <v-card class="mx-4 my-3">
              <PaymentEstimatorCard
                :plan="plan"
                :loanTotal="moneyInt(loanAmount)"
              />
            </v-card>
          </v-flex>
        </v-radio-group>
        <v-flex
          xs12
          v-if="checkPlanError && planError"
          class="my-2 subheading red--text"
        >
          A plan must be selected
        </v-flex>
        <AppNextButton
          v-if="showEstimates"
          :buttonFunction="goToForm"
        >
          Apply
        </AppNextButton>
      </responsive-flex>
    </v-layout>
  </div>
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import DisclaimerTooltip from 'Components/DisclaimerTooltip.vue'
  import LenderCard from 'Components/LenderCard.vue'
  import LoanInput from 'Components/LoanInput.vue'
  import Navbar from 'Components/Navbar.vue'
  import PaymentEstimatorCard from 'Components/PaymentEstimatorCard.vue'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'

  export default {
    name: 'PaymentEstimator',
    components: {
      AppNextButton,
      DisclaimerTooltip,
      LenderCard,
      LoanInput,
      Navbar,
      PaymentEstimatorCard,
      ResponsiveFlex,
    },
    data () {
      return {
        backPath: '/home',
        checkLoanError: false,
        currentPlan: {},
        disclaimerText: '*This amount equals the total purchases you plan ' +
          'to make. If approved, you may make purchases during the purchase ' +
          'window up to the credit limit that we set for your account. ' +
          'Purchase windows vary by plan. The Payment Estimator assumes that ' +
          'you will spend your full credit limit immediately following ' +
          'approval.<br/>Keep in mind that changing the amount or timing ' +
          'of purchases will change the actual payments required.',
        loanAmount: '$0',
        inputTitle: 'Enter Estimated Total*',
        showDisclaimer: false,
        showEstimates: false,
        checkPlanError: false
      }
    },
    computed: {
      ...mapGetters([
        'allPlans',
        'moneyInt'
      ]),
      ...mapState({
        lender: state => state.loanApplication.lender,
      }),
      loanError () {
        const amt = this.$store.getters.moneyInt(this.loanAmount)
        return !(amt >= 400)
      },
      planError () {
        return !this.currentPlan.id
      },
      showLoanError () {
        return this.checkLoanError && this.loanError
      }
    },
    methods: {
      ...mapActions([
        'setLender',
        'setLoanPlan',
        'setLoanAmount'
      ]),
      blurFunction () {
        this.removeDisclaimer()
        this.startLoanCheck()
      },
      calculateEstimates () {
        if (!this.loanError) {
          this.showEstimates = true
        }
      },
      goToForm () {
        if (!this.loanError && !this.planError) {
          const { loanAmount } = this
          this.setLoanAmount({ loanAmount })
          this.setLoanPlan(this.currentPlan)
          this.$router.push({
            path: '/credit-application/form-page-one'
          })
        } else {
          this.checkPlanError = true
          this.checkLoanError = true
        }
      },
      makeDisclaimerVisible () {
        this.showDisclaimer = true
      },
      removeDisclaimer () {
        this.showDisclaimer = false
      },
      startLoanCheck () {
        this.checkLoanError = true
      }
    },
    mounted () {
      this.setLender({
        companyLogo: require('Assets/greensky_img.png'),
        name: 'GreenSky Financing Plan',
        id: 'greensky',
        typeLabel: 'Prime'
      })
    }
  }
</script>
